<br /><br />
<div class="row justify-content-center">
  <mat-card class="col-md-4">
    <form [formGroup]="loginForm" style="text-align: center">
      <img
        width="60%"
        height="25%"
        src="../../../../assets/images/ares-userlogo.png"
      />
      <br /><br />
      <p class="font-weight-bold">Can we get your email to continue?</p>
      <mat-form-field style="width: 100%">
        <mat-label>Email</mat-label>
        <input
        type="email"  #emailInput id="emailInput" (blur)="onBlur($event)"
          matInput
          formControlName="email"
          onkeypress="return event.charCode != 32"
          [(ngModel)]="inputText"
          [readonly]="user" (input)="onInputChange()"
        />
        <mat-error *ngIf="loginForm.get('email').errors?.required">
          Email is required
        </mat-error>
        <mat-error *ngIf="loginForm.get('email').errors?.pattern">
          Please enter a valid email address
        </mat-error>
      </mat-form-field>
      <!-- <span [hidden]="!showResponseMessage" style="color: red">{{
        errorText
      }}</span> -->
      <br />
      <div class="btn-set-1" *ngIf="!user">
        <button mat-raised-button class="mr-2" (click)="cancelEmail()" type="button">
          I’m not ready yet
        </button>
        <button
          mat-raised-button type="submit"
          color="primary"
          (click)="submitEmail()"
          [disabled]="!loginForm.get('email').valid"
        >
          OK
        </button>
      </div>
      <div class="btn-set-2" *ngIf="user">
        <button mat-raised-button (click)="signUp()" class="mr-2">
          Complete Registration
        </button>
        <button mat-raised-button (click)="closePopup()" color="primary">
          {{ successButtonText }}
        </button>
      </div>
      <br /><br />
    </form>
  </mat-card>
</div>
